import { styled } from '@mui/system';

const HeadlineBackground = styled('div')(({ theme, color }) => ({
  width: '100%',
  backgroundColor: color || theme.palette.primary.main,
  height: 395,
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1,
  [theme.breakpoints.down('sm')]: {
    height: '60vh'
  }
}));

export default HeadlineBackground;
